import React from 'react';
import ReactDOM from 'react-dom';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { authService } from './services';
import App from './app.js'; 

/*******************************
 * Bugsnag setup
 *******************************/

const getReleaseState = () => {
    const host = window.location.hostname.toLowerCase().split( '.' )[ 0 ];

    if ( host === 'localhost' ) {
        return 'dev';
    }
    

    if ( host === 'qa' ) {
        return 'qa';
    }
    
    if ( host === 'pprd' ) {
        return 'pprd';
    }
    
    return 'prod';
};

Bugsnag.start( {
    apiKey: '2a3ea7d01e6a5f1dc5ce891b98cbd547',
    plugins: [ new BugsnagPluginReact() ],
    appVersion: '1.58.3',
    onError: function ( event ) {
        event.setUser( undefined, authService.getUserEmail(), authService.getUserId() );
        return true;
    },
    releaseStage: getReleaseState()
} );
 
BugsnagPerformance.start( { apiKey: '2a3ea7d01e6a5f1dc5ce891b98cbd547' } );

const ErrorBoundary = Bugsnag.getPlugin( 'react' ).createErrorBoundary( React );


/*******************************
 * Start App
 *******************************/

ReactDOM.render( 
    <ErrorBoundary>
        <App />
    </ErrorBoundary>, 
    document.getElementById( 'app-root' ) 
);
